export default class WebSocketClient {
  constructor(url, initData) {
    this._url = url;
    this._initData = initData;
    this._callbacks = {};
    this.tryTime = 1;
    this.init();
  }

  init() {
    this._ws = new WebSocket(this._url);
    this._ws.onopen = () => {
      this.onopen();
    };
    this._ws.onmessage = (e) => {
      this.onmessage(e);
    };
    this._ws.onclose = (e) => {
      this.onclose(e);
    };
  }

  onopen() {
    console.log("WebSocket open: ", this._url,this._initData);
    this._initData && this.send(this._initData);
  }

  onmessage(e) {
    // console.log("WebSocket message:", e);
    const data = JSON.parse(e.data);
    const type = e.type;
    if (type in this._callbacks) {
      this._callbacks[type](data);
    }
  }

  onclose(e) {
    // e.code === 1000  表示正常关闭。 无论为何目的而创建, 该链接都已成功完成任务。
    // e.code !== 1000  表示非正常关闭。
    console.log("---onclose--e---", e);
    if (e && e.code !== 1000) {
      console.error("ws连接异常，正在重试");
      if (this.tryTime < 5) {
        setTimeout(() => {
          this._ws = null;
          this.tryTime++;
          this.init();
          console.log(`第${this.tryTime}次重连`);
        }, 3 * 1000);
      } else {
        console.error("重连失败！请稍后重试");
      }
    }
  }
  send(data) {
    if (this._ws.readyState === WebSocket.OPEN) {
      this._ws.send(JSON.stringify(data));
    }
  }

  registerCallback(type, callback) {
    this._callbacks[type] = callback;
  }

  closeWebsocket() {
    if (this._ws) {
      this._ws.close(); // 关闭websocket
      this._ws.onclose(); // 关闭websocket
    }
  }
}
